import React from 'react';
import {useParams} from 'react-router-dom';
import {
  useAccountPoolQuery,
  ClientPreleadCustomizeItem,
  useUpdateAccountCustomizeItemDateMutation,
} from 'api';

export default ({item}: {item: ClientPreleadCustomizeItem}) => {
  const {accountId} = useParams<{accountId: string}>();
  const {data: {accountPool: {account = {}} = {}} = {}} = useAccountPoolQuery({
    variables: {uuid: accountId},
    skip: !accountId,
  });
  const [update] = useUpdateAccountCustomizeItemDateMutation({});

  return (
    <input
      type={'date'}
      className="rounded p-2 w-60 h-7 focus:outline-none focus:outline-[#E6E6E6] focus:outline-1"
      data-1p-ignore
      placeholder="未入力"
      defaultValue={
        account?.customizeItemPayload
          ? account?.customizeItemPayload[item.id]
          : ''
      }
      onChange={(e) => {
        update({
          variables: {
            uuid: account?.uuid,
            clientPreleadCustomizeItemId: item.id,
            value: e.target.value !== '' ? e.target.value : null,
          },
        });
      }}
    />
  );
};
